class PlaceSettings extends HTMLElement {

  constructor() {
    super();
    this.scope = null;
    this.summaryPriceEl = null;
    this.summaryComparePriceEl = null; // New property for compare-at price element
    this.addToCartBtn = null;
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
  }

  initializeElements() {
    // The "What's Included" list lives in a separate Shopify block
    // (`place_setting_included`) so it is OUTSIDE this <place-settings>
    // element. Walk up to the nearest [data-product-blocks] wrapper so we can
    // query elements in BOTH halves of the UI. Fall back to `this` if that
    // wrapper is not present (e.g., template change), so the page does not
    // break — the guest selector + ATC still work for non-split layouts.
    this.scope = this.closest("[data-product-blocks]") || this;

    // These three live inside <place-settings>, so `this.` is still correct.
    this.summaryPriceEl = this.querySelector(".summaryprice");
    this.summaryComparePriceEl = this.querySelector(".summarycompareprice");
    this.addToCartBtn = this.querySelector(".placeaddtocart .btn");
  }

  setupEventListeners() {
    // Guest selection — inside <place-settings>
    this.querySelectorAll(".gsitem").forEach((item) => {
      item.addEventListener("click", this.handleGuestSelection.bind(this));
    });

    // Quantity changes — in the split-off "What's Included" block, so query the scope
    this.scope.querySelectorAll(".js-qty__num").forEach((input) => {
      input.addEventListener("change", this.updateTotalPrice.bind(this));
    });

    // Quantity adjust buttons — also in the split-off block
    this.scope.querySelectorAll(".js-qty__adjust").forEach((button) => {
      button.addEventListener("click", this.handleQuantityAdjust.bind(this));
    });

    // Add to cart — inside <place-settings>
    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener(
        "click",
        this.handleAddToCart.bind(this)
      );
    }
  }

  handleGuestSelection(event) {
    const target = event.currentTarget;
    this.querySelectorAll(".gsitem").forEach((item) =>
      item.classList.remove("selected")
    );
    target.classList.add("selected");
    this.updateQuantitiesAndPrice();
  }

  updateQuantitiesAndPrice() {
    const guests = parseInt(
      this.querySelector(".gsitem.selected").dataset.guests
    );
    const multiplier = guests / 8;

    let newCost = 0;
    let newCompareCost = 0; // Initialize compare-at cost

    this.scope.querySelectorAll(".quancontrol").forEach((control) => {
      const per8 = parseInt(control.dataset.per8);
      const singleOnly = control.dataset.singleonly === "true";
      const price = parseInt(control.dataset.cost);

      // Get the compare-at cost
      const compareCost = parseInt(control.dataset.comparecost);

      const input = control.querySelector(".js-qty__num");

      let quantity = singleOnly ? per8 : per8 * multiplier;
      input.value = Math.round(quantity);

      newCost += price * quantity;

      // Calculate compare-at cost
      newCompareCost += compareCost * quantity;
    });

    this.summaryPriceEl.textContent = theme.Currency.formatMoney(newCost);

    // Update compare-at price display
    this.updateComparePriceDisplay(newCost, newCompareCost);
  }

  updateTotalPrice() {
    let newCost = 0;
    let newCompareCost = 0; // Initialize compare-at cost

    this.scope.querySelectorAll(".quancontrol").forEach((control) => {
      const price = parseInt(control.dataset.cost);
      // Get the compare-at cost
      const compareCost = parseInt(control.dataset.comparecost);

      const quantity = parseInt(control.querySelector(".js-qty__num").value);

      newCost += price * quantity;
      // Calculate compare-at cost
      newCompareCost += compareCost * quantity;
    });

    this.summaryPriceEl.textContent = theme.Currency.formatMoney(newCost);

    // Update compare-at price display
    this.updateComparePriceDisplay(newCost, newCompareCost);
  }

  // Helper function to manage compare-at price visibility and content
  updateComparePriceDisplay(currentPrice, currentComparePrice) {
    if (!this.summaryComparePriceEl) return;

    // Check if the compare price is valid (greater than the current price)
    if (currentComparePrice > currentPrice) {
      const formattedPrice = theme.Currency.formatMoney(currentComparePrice);

      // 1. Update the content, wrapped in a <span>
      this.summaryComparePriceEl.innerHTML = `<span>${formattedPrice}</span>`;

    } else {
      // 3. Hide the element and clear its content
      this.summaryComparePriceEl.innerHTML = "";

    }
  }

  handleQuantityAdjust(event) {
    const button = event.currentTarget;
    const input = button.parentElement.querySelector(".js-qty__num");
    const currentValue = parseInt(input.value);



    // Dispatching the 'change' event will call this.updateTotalPrice()
    input.dispatchEvent(new Event("change"));
  }

  async handleAddToCart() {
    this.addToCartBtn.classList.add("btn--loading");

    const items = Array.from(this.scope.querySelectorAll(".quancontrol")).map(
      (control) => {
        const input = control.querySelector(".js-qty__num");
        const id = parseInt(input.id.split("-")[1]);
        return {
          id: id,
          quantity: parseInt(input.value),
        };
      }
    );

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      const product = await response.json();

      // FIX: theme.js's CartDrawer listens for "ajaxProduct:added" dispatched
      // on `document` (with bubbles:true when fired from a form). The old
      // code dispatched "added.ajaxProduct" on document.body with no
      // `bubbles` flag — wrong event name AND it never reached the
      // document-level listener, so the drawer never opened even though the
      // item was successfully added to the cart. Dispatching directly on
      // `document` with the correct name fixes both issues at once.
      document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
        detail: { product, addToCartBtn: this.addToCartBtn },
      }));

      if (window.Rebuy && window.Rebuy.SmartCart) {
        window.Rebuy.Cart.fetchCart(() => {
          window.Rebuy.SmartCart.show();
        });
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    } finally {
      this.addToCartBtn.classList.remove("btn--loading");
      console.log('CarlowSEO - Place Setting Added to Cart 2.26.26')
    }
  }
}

customElements.define("place-settings", PlaceSettings);